module.exports = __webpack_public_path__ + "media/hero-mobile_1.521a4c15.mp4";